import { render, staticRenderFns } from "./select-paymentType.vue?vue&type=template&id=236a7ea0&scoped=true"
import script from "./select-paymentType.vue?vue&type=script&lang=js"
export * from "./select-paymentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a7ea0",
  null
  
)

export default component.exports